import React, { useState } from 'react'
import { useSnackbar } from 'notistack'
import { useForm } from 'react-hook-form'
import { useStyles } from './FormAdressContactStyle'
import AdresseAutoComplete from '../../AdresseAutoComplete/AdresseAutoComplete'
import SelectPays from '../../SelectPays/SelectPays'
import { useDispatch, useSelector } from 'react-redux'

//Material UI
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import { FormControl, FormHelperText } from '@mui/material'


export default function FormAdressContact(props) {
  const classes = useStyles()
  const { handleSubmit, setValue } = useForm()
  const { formClass, defaultValues, pays, adresseTypes, postCodes, save, errors, register, errorsForm, formAdressNumber } = props
  const [prefixe, setPrefixe] = useState(defaultValues?.CONTURG_ADRESSEBISTER ?? '')
  const [adresseType, setAdresseType] = useState(defaultValues?.CONTURG_TERM_ID ?? '')
  const [adresse, setAdresse] = useState({ nom: defaultValues?.CONTURG_VILLE, code: defaultValues?.CONTURG_CP })
    
  return (
    <>
      <form onChange={handleSubmit(save)} onError={errorsForm}>
        <div className={formClass}>
          <div className={classes.formLine}>
            <FormControl>
              <TextField
                label="Numéro"
                variant="outlined"
                type="number"
                name={`contacts.${formAdressNumber}.CONTURG_ADRESSE1`}
                className={classes.selectFullLine}
                margin="dense"
                inputRef={register({
                  required: 'Ce champ est requis',
                  pattern: {
                    value: /^[0-9]*$/,
                    message: 'Ce champ doit être un nombre'
                  }
                })}
                error={!!errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ADRESSE1}
                required
                helperText={errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ADRESSE1?.message}
                defaultValue={defaultValues?.CONTURG_ADRESSE1}
              />
            </FormControl>

            <TextField
              select
              label=" "
              variant="outlined"
              value={prefixe}
              onChange={(e) => {
                setPrefixe(e.target.value)
                save({
                  CONTURG_ADRESSEBISTER: e.target.value
                })
              }}
              margin="dense"
              inputRef={register}
              name={`contacts.${formAdressNumber}.CONTURG_ADRESSEBISTER`}
            >
              <MenuItem value=""></MenuItem>
              <MenuItem value="Bis">Bis</MenuItem>
              <MenuItem value="Ter">Ter</MenuItem>
            </TextField>

            <TextField
              select
              label="Type d'adresse"
              variant="outlined"
              className={classes.selectFullLine}
              margin="dense"
              required
              onChange={(e) => {
                save({
                  CONTURG_TERM_ID: e.target.value
                })
                setAdresseType(e.target.value)
              }}
              defaultValue={defaultValues?.CONTURG_TERM_ID ?? ''}
              name={`contacts.${formAdressNumber}.CONTURG_TERM_ID`}
              inputProps={{ name: `contacts.${formAdressNumber}.CONTURG_TERM_ID`, ref: register({ required: 'Ce champ est requis', minLength: 1 }) }}
              error={adresseType.length > 1}
              helperText={adresseType.length > 1 && 'Ce champ est requis'}
            >
              {adresseTypes.map((a, i) => (<MenuItem value={a.id} name={a.libelle} key={i}>{a.libelle}</MenuItem>))}
            </TextField>
          </div>

          <div>
            <TextField
              label="Ligne 1"
              className={classes.selectFullLine}
              variant="outlined"
              type="text"
              name={`contacts.${formAdressNumber}.CONTURG_ADRESSE2`}
              margin="dense"
              inputRef={register({
                required: 'Ce champ est requis',
                minLength: 1,
                pattern: {
                  value: /^[a-zA-Z0-9\s]*$/,
                }
              })}
              inputProps={{ style: { textTransform: "lowercase" } }}
              required
              error={!!errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ADRESSE2}
              defaultValue={defaultValues?.CONTURG_ADRESSE2 ?? ''}
              helperText={errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ADRESSE2?.message}
            />
          </div>

          <div>
            <TextField
              label="Ligne 2"
              className={classes.selectFullLine}
              variant="outlined"
              type="text"
              name={`contacts.${formAdressNumber}.CONTURG_ADRESSE3`}
              margin="dense"
              inputProps={{ style: { textTransform: "lowercase" } }}
              inputRef={register}
              error={!!errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ADRESSE3}
              defaultValue={defaultValues?.CONTURG_ADRESSE3}
              helperText={errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ADRESSE3?.message}
            />
          </div>

          <div className={classes.formLineTwo}>
            <div>
              <TextField
                className={classes.selectFullLine}
                label="Bâtiment"
                variant="outlined"
                type="text"
                name={`contacts.${formAdressNumber}.CONTURG_BATIMENT`}
                error={!!errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_BATIMENT}
                margin="dense"
                inputRef={register}
                defaultValue={defaultValues?.CONTURG_BATIMENT}
                helperText={errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_BATIMENT?.message}
              />
            </div>

            <div>
              <TextField
                label="Escalier"
                variant="outlined"
                type="text"
                className={classes.selectFullLine}
                name={`contacts.${formAdressNumber}.CONTURG_ESCALIER`}
                error={!!errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ESCALIER}
                margin="dense"
                inputRef={register}
                defaultValue={defaultValues?.CONTURG_ESCALIER}
                helperText={errors.contacts && errors.contacts[formAdressNumber]?.CONTURG_ESCALIER?.message}
              />
            </div>
          </div>
        </div>
        <div>
          <AdresseAutoComplete
            register={register}
            required
            value={adresse}
            //nameVille={`contacts.${formAdressNumber}.CONTURG_VILLE`}
            //nameCodePostal={`contacts.${formAdressNumber}.CONTURG_CP`}
            setValue={(e) => {
              save({
                CONTURG_VILLE: e.nom,
                CONTURG_CP: e.code
              })
              setAdresse(e)
            }}
            postCodes={postCodes}
          />
        </div>

        <div>
          <SelectPays
            required
            name={`contacts.${formAdressNumber}.CONTURG_PAYS_ID`}
            register={register}
            label="Pays"
            setPays={(e) => {
              save({
                CONTURG_PAYS_ID: e
              })
            }}
            defaultValue={defaultValues?.CONTURG_PAYS_ID}
            pays={pays}
          />
        </div>
      </form>
    </>
  )
}
